import React from 'react'
import PropTypes from 'prop-types'
import * as validators from '../../../validators'
import style from './style'
import Form from '../../../components/Form'
import { Dropdown } from '../../../components/Fields'
import { translations } from '../../../config'

const MarketingOptInForm = Form('marketing-opt-in')
const options = [{ value: 'english', label: 'English' }, { value: 'french', label: 'French' }]
const MarketingOptInFormWrapper = ({
  onSubmit,
  errorMessage
}) => {
  return (
    <div>
      <div style={style.generalError}>{errorMessage}</div>
      <MarketingOptInForm onSubmit={onSubmit} submitLabel={translations('SUBMIT')}>
        <Dropdown
          floatingLabelText={translations('Primary language')}
          name='language'
          options={options}
          style={style.field}
          validate={[validators.required]}
        />
      </MarketingOptInForm>
    </div>
  )
}

MarketingOptInFormWrapper.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  error: PropTypes.string
}

export default MarketingOptInFormWrapper



// WEBPACK FOOTER //
// ./src/containers/MarketingOptIn/MarketingOptInForm/MarketingOptInForm.js